import { map, mergeDeepRight } from 'ramda'

const pages =
  [
    {
      path: 'message-detail',
      name: 'message-detail',
      component: () => import(/* webpackChunkName: "message-detail" */ '@/views/h5/message-detail/index.vue')
    }
  ] |> map(mergeDeepRight({ meta: { requireLogin: false, notShowDialog: true } }))

export default pages
